export default import.meta.ROLLUP_FILE_URL_d8OSeCWdN9w0fLWrzTXMEQ